// You can specify which plugins you need
import { Tooltip, Modal } from 'bootstrap';

// Enable tooltips everywhere
var tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl);
});

// Add active class to bootstrap accordion
document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.accordion-item');

  accordionItems.forEach((item) => {
    item.addEventListener('show.bs.collapse', function () {
      item.classList.add('active');
    });

    item.addEventListener('hide.bs.collapse', function () {
      item.classList.remove('active');
    });
  });
});

// Change range slider input value when clicked on datalist option
document.addEventListener('DOMContentLoaded', function () {
  const rangeSliderItems = document.querySelectorAll('input[type="range"]');

  rangeSliderItems.forEach((item) => {
    const listID = item.getAttribute('list'),
      datalist = document.querySelector('datalist[id="' + listID + '"]');

    Array.from(datalist.options).forEach((datalistOption) => {
      datalistOption.addEventListener('click', () => {
        item.value = datalistOption.value;
      });
    });
  });
});

// Fix scrollbar placeholder on show modal
document.addEventListener('DOMContentLoaded', function () {
  // Callback function to execute when mutations are observed
  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'style'
      ) {
        // Pause the observer
        observer.disconnect();

        const computedStyle = window.getComputedStyle(document.body);
        const paddingRight = computedStyle.getPropertyValue('padding-right');
        const paddingLeft = computedStyle.getPropertyValue('padding-left');

        let value = 0;

        if (paddingRight != '0px') value = paddingRight;

        if (paddingLeft != '0px') value = paddingLeft;

        document.body.style.setProperty('--modal-scrollbar-width', value);

        // Restart the observer
        observer.observe(document.body, {
          attributes: true, // Observe attribute changes
          attributeFilter: ['style'], // Only observe changes to the style attribute
        });
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(document.body, {
    attributes: true, // Observe attribute changes
    attributeFilter: ['style'], // Only observe changes to the style attribute
  });
});
